import { ChevronDown, Pencil, Pin, PinOff, Trash2 } from 'lucide-react';
import { useState } from 'react';

import { cn } from '@/lib/utils';

import { AnimatedThreadName } from '@/components/DMAnimations/AnimatedThreadName';
import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';

interface ThreadActionsMenuProps {
    threadId?: string;
    threadName: string;
    isPinned: boolean;
    isAdmin: boolean;
    canDelete: boolean;
    onInlineRename: () => void;
    onDialogRename: () => void;
    onPinToggle: () => void;
    onDelete: () => void;
}

export function ThreadActionsMenu({
    threadId,
    threadName,
    isPinned,
    isAdmin,
    canDelete,
    onInlineRename,
    onDialogRename,
    onPinToggle,
    onDelete
}: ThreadActionsMenuProps) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <div
            className={cn(
                'group/thread hidden lg:flex items-center gap-0.5 hover:bg-muted/60 rounded-md',
                isMenuOpen && 'bg-muted/60'
            )}
        >
            <Button
                onClick={onInlineRename}
                variant="ghost"
                className="focus-visible:z-10 lg:flex rounded-none rounded-l-md px-2.5 min-w-0 md:max-w-[37.5rem] h-8 overflow-hidden text-base leading-6"
                title="Click to rename"
            >
                <AnimatedThreadName
                    threadId={threadId}
                    name={threadName}
                    className="truncate"
                />
            </Button>
            <div
                className={cn(
                    'bg-border w-px h-6 transition-opacity duration-150',
                    isMenuOpen
                        ? 'opacity-100'
                        : 'opacity-0 group-hover/thread:opacity-100 group-focus-within/thread:opacity-100'
                )}
            />
            <DropdownMenu open={isMenuOpen} onOpenChange={setIsMenuOpen}>
                <DropdownMenuTrigger asChild>
                    <Button
                        variant="ghost"
                        size="icon-sm"
                        className="rounded-none rounded-r-md"
                    >
                        <ChevronDown />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent
                    align="start"
                    className="bg-background min-w-[calc(100%+1rem)]"
                >
                    <DropdownMenuItem
                        onClick={onDialogRename}
                       
                    >
                        <Pencil />
                        <span>
                            Rename thread
                        </span>
                    </DropdownMenuItem>
                    {isAdmin && (
                        <DropdownMenuItem
                            onClick={onPinToggle}
                           
                        >
                            {isPinned ? (
                                <>
                                    <PinOff
                                       
                                    />
                                    <span>
                                        Unpin from organization
                                    </span>
                                </>
                            ) : (
                                <>
                                    <Pin
                                       
                                    />
                                    <span>
                                        Pin to organization
                                    </span>
                                </>
                            )}
                        </DropdownMenuItem>
                    )}
                    {canDelete && (
                        <>
                            <DropdownMenuSeparator />
                            <DropdownMenuItem
                                variant="destructive"
                                onClick={onDelete}
                               
                            >
                                <Trash2 />
                                <span>
                                    Delete thread
                                </span>
                            </DropdownMenuItem>
                        </>
                    )}
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}
